function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Provider } from 'react-redux';
import { SHOW_LOADER_AFTER_MS } from 'swag-client-common/constants';
import Page from '../page';
import Root from '../../containers/root';
import { customerStore } from '../../redux/swag.store';
import classes from './suspense-fallback.scss';
function SuspenseFallback({
  headerIsViolet,
  otherHeaderProps
}) {
  const [loading, setIsLoading] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => setIsLoading(true), SHOW_LOADER_AFTER_MS);
    return () => clearTimeout(timer);
  });
  return /*#__PURE__*/React.createElement(Provider, {
    store: customerStore
  }, /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(Page, _extends({
    headerIsViolet: headerIsViolet,
    loading: loading,
    autoChatbox: false,
    showCategories: false,
    isSuspenseFallback: true
  }, otherHeaderProps), /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }))));
}
export default SuspenseFallback;